import { OnboardingStatus, User } from '@admiin-com/ds-graphql';
import { needsOnboarding } from '@admiin-com/ds-common';
import type { NavigateFunction, NavigateOptions } from 'react-router-dom';
import { PATHS } from '../navigation/paths';

export const getOnboardingPath = (input: User | OnboardingStatus) => {
  let onboardingStatus: OnboardingStatus | null | undefined;
  let firmId: string | null = null;
  // Check if 'input' is a User object by checking for a specific property
  if (input && typeof input === 'object' && 'onboardingStatus' in input) {
    onboardingStatus = input.onboardingStatus;
    firmId = input?.firmId ?? null;
  } else {
    onboardingStatus = input as OnboardingStatus;
  }

  switch (onboardingStatus) {
    case OnboardingStatus.PROFILE:
      return PATHS.onboardingName;

    // case OnboardingStatus.PROFILE_IMAGE:
    //   return PATHS.onboardingProfileImage;

    case OnboardingStatus.BUSINESS:
      return PATHS.onboardingBusiness;

    case OnboardingStatus.COMPLETED:
      return firmId ? PATHS.home : PATHS.tasks;

    default:
      return firmId ? PATHS.home : PATHS.tasks;
  }
};

export const getSignInRedirectPath = (
  user: User,
  lastEntityId: string | null,
  hasClients: boolean
) => {
  if (!user?.firmId || (lastEntityId && lastEntityId !== user.firmId)) {
    return PATHS.tasks;
  }
  return hasClients ? PATHS.home : PATHS.clients;
};

export const redirectToOnboarding = (
  user: User,
  navigate: NavigateFunction,
  options?: NavigateOptions
) => {
  if (needsOnboarding(user)) {
    navigate(getOnboardingPath(user), options);
    return true;
  }
  return false;
};
